import React from "react";
import { BrowserRouter as Router, Routes, Route, useLocation } from "react-router-dom";

import Header from "./components/Header";
import Footer from "./components/Footer";
import ScrollTop from "./components/ScrollTop";
import Preloader from "./components/Preloader";
import AboutPage from "./pages/AboutPage";
import CoursesPage from "./pages/CoursesPage";
import CourseDetailsPage from "./pages/CourseDetailsPage";
import ArticlesPage from "./pages/ArticlesPage";
import ArticleDetailsPage from "./pages/ArticleDetailsPage";
import StudentEnquiriesPage from "./pages/StudentEnquiriesPage";
import ContactPage from "./pages/ContactPage";
import AdmissionsPolicyPage from "./pages/AdmissionsPolicyPage";
import LibraryResources from "./pages/LibraryResourcesPage";
import StudentQuestionnairePage from "./pages/StudentQuestionnairePage ";
import VideosAndReferences from "./pages/VideoAndReferencesPage";
import WhoWeAre from "./pages/WhoWeArePage";
import StudentInfoDownloads from "./pages/StudentInfoDownloadsPage";
import HomePage from "./pages/HomePage";
import AlumniPage from "./pages/AlumniPage";
import PostJobPage from "./pages/PostJobPage";
import AlumniApplyPage from "./pages/AlumniApplyPage";
import MentorApplicationPagev from "./pages/MentorApplicationPage";
import DonatePage from "./pages/DonatePage";
import JobsPage from "./pages/JobsPage";
import OnlineClassesPage from "./pages/OnlineClassesPage";
import StudentResources from "./pages/StudentResources";
import FeeStructurePage from "./pages/FeeStructurePage";
import EthicsCommitteePage from "./pages/EthicsCommitteePage";
import ExcelCertificatePage from "./pages/ExcelCertificatePage";
import ApplicationPage from "./pages/ApplicationPage";
import ElectionsPage from "./pages/ElectionsPage";
import StudentUnionPage from "./pages/StudentUnionPage";


const App = () => {
  const AppShell = () => {
    const { pathname } = useLocation();
    const hideHeader = pathname === "/excel-certificate";

    React.useEffect(() => {
      window.scrollTo(0, 0);
    }, [pathname]);

    return (
      <>
        <Preloader />
        {!hideHeader ? <Header /> : null}
        <main className={hideHeader ? "" : "mt-16"}>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/courses" element={<CoursesPage />} />
            <Route path="/course/:id" element={<CourseDetailsPage />} />
            <Route path="/articles" element={<ArticlesPage />} />
            <Route path="/article/:id" element={<ArticleDetailsPage />} />
            <Route path="/student-enquiries" element={<StudentEnquiriesPage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/admissions" element={<AdmissionsPolicyPage />} />
            <Route path="/fee-structure" element={<FeeStructurePage />} />
            <Route path="/ethics-committee" element={<EthicsCommitteePage />} />
            <Route path="/library-resources" element={<LibraryResources />} />
            <Route path="/student-questionnaire" element={<StudentQuestionnairePage />} />
            <Route path="/videos-and-references" element={<VideosAndReferences />} />
            <Route path="/who-we-are" element={<WhoWeAre />} />
            <Route path="/student-info-downloads" element={<StudentInfoDownloads />} />
            <Route path="/alumni" element={<AlumniPage />} />
            <Route path="/alumni/apply" element={<AlumniApplyPage />} />
            <Route path="/alumni/jobs/post" element={<PostJobPage />} />
            <Route path="/alumni/mentors/apply" element={<MentorApplicationPagev />} />
            <Route path="/donate" element={<DonatePage />} />
            <Route path="/jobs" element={<JobsPage />} />
            <Route path="/online-classes" element={<OnlineClassesPage />} />
            <Route path="/student-resources" element={<StudentResources />} />
            <Route path="/excel-certificate" element={<ExcelCertificatePage />} />
            <Route path="/apply" element={<ApplicationPage />} />
            <Route path="/elections" element={<ElectionsPage />} />
            <Route path="/student-union" element={<StudentUnionPage />} />
          </Routes>
        </main>
        <Footer />
        <ScrollTop />
      </>
    );
  };

  return (
    <Router>
      <AppShell />
    </Router>
  );
};

export default App;
